export default "__VITE_ASSET__jBrH_zNB__"